import { render, staticRenderFns } from "./whatsapp-button.vue?vue&type=template&id=23483ae6&scoped=true&lang=pug&"
import script from "./whatsapp-button.vue?vue&type=script&lang=ts&"
export * from "./whatsapp-button.vue?vue&type=script&lang=ts&"
import style0 from "./whatsapp-button.vue?vue&type=style&index=0&id=23483ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23483ae6",
  null
  
)

export default component.exports